import { getRequestHeader } from "h3";
import api from "~/api";
import { resolveSiteLang } from "@/shared/utils/browserLang";

export default defineNuxtRouteMiddleware(async (to) => {
  const bellaPartner = useCookie("bellaPartner", {
    maxAge: 60 * 60 * 24 * 365,
    sameSite: "none",
    secure: process.env.NODE_ENV === "production",
    httpOnly: true,
    domain: '.belladasemana.com.br', // Adjust the domain as needed
    priority: 'high', // Set priority to high
  });
  const userLang = to.params.language as string;
  const langPermission = ["pt-br", "en"];
  if (!langPermission.includes(userLang) && userLang) {
    // Idioma de fallback pela preferência REAL do navegador (Accept-Language no
    // SSR, navigator no client) — NÃO pelo slug. O slug aqui é um valor arbitrário
    // (ex.: código de afiliado inválido), então usá-lo para decidir idioma jogava
    // tudo em /en. Calculado ANTES do await para não perder o contexto de
    // useRequestEvent().
    const event = import.meta.server ? useRequestEvent() : null;
    const acceptLang = import.meta.server
      ? event ? getRequestHeader(event, "accept-language") ?? "" : ""
      : navigator.languages?.join(",") || navigator.language;
    const fallbackLang = resolveSiteLang(acceptLang);

    try {
      const { data } = await api.get(`/v1/affiliate/valida/${userLang}/affiliate`, {
        withCredentials: true,
      });
      bellaPartner.value = data.affiliates_id;
      return await navigateTo(data.link, { external: true });
    } catch {
      // O slug não é idioma nem afiliado válido. Se não sobra caminho depois dele
      // (`/codigo-invalido`), não há para onde levar o visitante além da home — e
      // redirecionar URL inexistente para a home é o padrão que o Google classifica
      // como soft 404. Devolver 404 de verdade é o correto: a URL não existe.
      // Efeito colateral: link de afiliado expirado passa a exibir a página de erro
      // em vez da home (afiliado VÁLIDO continua redirecionando normalmente, acima).
      const rest = to.path.slice(userLang.length + 1);
      if (!rest || rest === "/") {
        throw createError({ statusCode: 404, statusMessage: "Not Found" });
      }

      // Sobra caminho real (`/xx/modelos/foo`): só o idioma estava errado, então
      // vale trocar o prefixo e preservar o resto. Se o destino também não existir,
      // o 404 sai de lá.
      return await navigateTo(`/${fallbackLang}${rest}`);
    }
  }
});
